import cn from 'clsx';
import format from 'date-fns/format';
import en from 'date-fns/locale/en-US';
import ru from 'date-fns/locale/ru';
import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';

import { useStore } from 'hooks/useStore';
import { capitalize } from 'utils/string/format';

import css from './List.module.css';

interface ListProps {
  dates: DateOption[];
}

interface IDateOptionInputElement extends HTMLInputElement {
  value: DateOptionId;
}

const locales = {
  ru,
  en,
};

const List = (props: ListProps) => {
  const {
    app: { locale, i18n },
    filter: { loadDate },
    ui: { toggleIsDateOptionsExpanded },
  } = useStore();
  const { dates } = props;

  const getDateOptionDesc = (date: DateOption) => {
    const dayOfMonthFormat = (date: Date | undefined) => date && format(date, 'd MMMM', { locale: locales[locale] });
    const dayOfWeekFormat = (date: Date | undefined) => date && format(date, 'EEEEEE', { locale: locales[locale] });

    const daysOfMonth = [date.start, date.end].map(dayOfMonthFormat).filter(Boolean).join('—');
    const daysOfWeek = [date.start, date.end].map(dayOfWeekFormat).filter(Boolean).join('—');

    const description = [daysOfMonth, daysOfWeek].join(', ');

    return date.isUnclosed
      ? `${capitalize(i18n.dates.from)} ${description} ${i18n.dates.withoutRestrictions}`
      : description;
  };

  const handleChange = (e: ChangeEvent<IDateOptionInputElement>) => {
    loadDate.setDateOption(e.currentTarget.value);
    toggleIsDateOptionsExpanded();
  };

  return (
    <ul className={cn(css.list, 'glz-z-dropdown-list glz-dropdown-list')}>
      {dates.map(date => {
        if (date.id === 'manual') return null;

        return (
          <li key={date.id} className={cn(css.listItem, 'glz-dropdown-list-item')}>
            <label className={css.optionLabel}>
              <input
                checked={date.id === loadDate.dateOption}
                type="radio"
                value={date.id || ''}
                onChange={handleChange}
              />

              <div className={css.description}>
                {date.caption}
                <span>{getDateOptionDesc(date)}</span>
              </div>
            </label>
          </li>
        );
      })}
    </ul>
  );
};

const connected = observer(List);

export { connected as List };
